export const bbc = 'ReithSans, Helvetica, Arial, sans-serif'
export const bbcserif = 'ReithSerif, Helvetica, Arial, sans-serif'
export const monospace = 'Menlo, monospace'
export const fontRootSize = 16

export const fonts = {
  bbc,
  monospace,
  bbcserif
}
